import {
  Textarea as TextareaComponent,
  TextareaError,
  TextareaRoot,
  TextareaPrimitive,
  TextareaProps
} from "@packages/ds";

// Re-export with original names for backward compatibility
export const Textarea = TextareaPrimitive;
export const Error = TextareaError;
export const Root = TextareaRoot;

// Export the main component
export { TextareaComponent };
export type { TextareaProps };

// Default export for backward compatibility
export default TextareaComponent;
